<template>
  <v-card>
    <v-container class="d-flex">
      <v-icon class="mr-3">mdi-format-list-text</v-icon>
      <h3 v-text="$t('servicesystem.pages.site_settings.list_item_customization')"
          class="align-self-center" />
    </v-container>
    <v-divider />
    <v-list class="py-0">
      <v-list-item>
        <q-button-group v-model="JobListViewOptions"
                        :list="list"
                        :multiple="true"
                        :edit="true">
        </q-button-group>
      </v-list-item>
      <v-card class="pa-4"
              elevation="0">
        <job-li :jobItem="jobitem"
                :noclick="true">
        </job-li>
      </v-card>
      <v-divider />
    </v-list>
  </v-card>
</template>


<script>
import JobLi from "@/components/ListItems/JobListItem/JobListItem.vue";
import DummyJob from "@/api/dummy-data/job-item";

export default {
  components: { JobLi },

  data() {
    return {
      list: [
        { id: 0, value: "Machines", icon: "$machine", text: this.$t("servicesystem.common_objects.machine.machines") },
        {
          id: 1,
          value: "Appointments",
          icon: "$appointment",
          text: this.$t("servicesystem.common_objects.appointment.appointments"),
        },
        { id: 2, value: "Compact", icon: "mdi-card-text-outline", text: "Compact" },
      ],

      jobitem: DummyJob,
    };
  },

  mounted() {},

  methods: {},

  computed: {
    JobListViewOptions: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("JobListViewOptions");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "JobListViewOptions", value: update });
      },
    },
  },
};
</script>
